import catlist from './catlist'
import detail from './detail'
import recommend from './recommend'
import subscribe from './subscribe'
import top from './top'
import tracks from './tracks'

export default {
  catlist,
  detail,
  recommend,
  subscribe,
  top,
  tracks
}
